import React from "react";

import type { INavigation, INavMenu } from "../../types";

import ItemButton from "./ItemButton";
import ItemLink from "./ItemLink";

import { PageList } from ".";

interface Props {
  items: INavigation["left"];
  onPageChange: (page: INavMenu) => void;
}

export default function RootMenu({ items, onPageChange }: Props) {
  return (
    <PageList>
      {(items || []).map((item) => {
        if (item._type === "navLink") {
          return (
            <li key={item.text}>
              <ItemLink
                to={
                  item.link.to || item.link.toExternal || item.link.hash || "#"
                }
                noFollow={item.link.noFollow}
              >
                {item.text}
              </ItemLink>
            </li>
          );
        }
        return (
          <li key={item.text}>
            <ItemButton
              title={item.text}
              subtitle={item.description}
              onClick={() => onPageChange(item)}
            />
          </li>
        );
      })}
    </PageList>
  );
}
